import { Box } from '@mui/material';
import React, { useEffect } from 'react';
import DialogMediaPlayer from '../../../../../DialogMediaPlayer/DialogMediaPlayer';
import { ReactPlayerProps } from 'react-player';
import usePractitionerControlsContext from '../../../../../../hooks/usePractitionerControlsContext/usePractitionerControlsContext';
import { VideoContentPanelStyle } from './VideoContentPanelStyle';
import { SourceProjection } from '../../../../../../commands/practitioner/enums/SourceProjection';
import DefaultVideo from '../../../../../../assets/no-video.svg';
import { PLayerTriggeredBy } from '../../../../../../commands/practitioner/enums/PLayerTriggeredBy';
import { MediaTypes } from '../../../../../../commands/practitioner/enums/MediaTypes';

interface VideoContentPanelProps {
  className?: string;
  index: number;
  value: number;
}

const VideoContentPanel = (props: VideoContentPanelProps) => {
  const { index, value } = props;

  const { practitionerMediaURI, setProjectionType, isMediaLoaded } = usePractitionerControlsContext();
  const { videoTabContainer } = VideoContentPanelStyle;

  const config = {
    youtube: {
      playerVars: {
        showinfo: 1,
        origin: window.location.origin,
      },
    },
  };

  const reactPlayerPreview: ReactPlayerProps = {
    url: practitionerMediaURI,
    width: '100%',
    height: '100%',
    config,
    controls: false,
  };

  useEffect(() => {
    setProjectionType(SourceProjection.Flat);
  }, [value]);

  return (
    <Box
      sx={videoTabContainer}
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
    >
      {value === index && (
        <>
          <Box className={'video-container'}>
            {!!practitionerMediaURI && isMediaLoaded ? (
              <DialogMediaPlayer
                key={practitionerMediaURI}
                ReactPlayerProps={reactPlayerPreview}
                ReactPlayerTriggeredBy={PLayerTriggeredBy.Practitioner}
              />
            ) : (
              <Box className="video-default">
                <img className={'img'} src={DefaultVideo} alt="blanc-img" />
              </Box>
            )}
          </Box>
        </>
      )}
    </Box>
  );
};

export default VideoContentPanel;
